import { useTooltip } from "hooks/useTooltip";

export const Snail = () => {
    const { tooltipRef } = useTooltip({ title: "Shelley" });

    return (
        <div id="snail-holder" ref={tooltipRef}>
            <div id="snail">
                <div id="shell"></div>
                <div id="slug"></div>
            </div>
            <div id="slime"></div>
        </div>
    );
};
